import iconTowels from 'assets/icons/towels.svg'
import iconFlipFlops from 'assets/images/decors/wellness/iconFlipFlops.svg'
import iconJacuzzi from 'assets/images/decors/wellness/iconJacuzzi.svg'
import iconSpa from 'assets/images/decors/wellness/iconSpa.svg'
import exampleGalleryPhoto1 from 'assets/images/gallery/exampleGalleryPhoto_1.jpg'
import exampleGalleryPhoto2 from 'assets/images/gallery/exampleGalleryPhoto_2.jpg'
import exampleGalleryPhoto3 from 'assets/images/gallery/exampleGalleryPhoto_3.jpg'
import Box from 'components/shared/Box'
import Gallery from 'components/shared/Gallery'
import SinglePhoto from 'components/shared/Gallery/SinglePhoto'
import IconWithText from 'components/shared/IconWithText'
import Link from 'components/shared/Link'
import Modal from 'components/shared/Modal'
import OpeningHours from 'components/shared/OpeningHours'
import Text from 'components/shared/Text'
import {
    SPA_CONTRAINDICATIONS_DOC,
    SUNTAGO_ONLINE_TICKET_SALES_REGULATIONS_LINK,
} from 'constants/links'
import { FormattedMessage, useIntl } from 'react-intl'
import { SpaModalBody } from './styles'
import { UpsellModalProps } from './types'

const SpaModal = ({ isOpened, closeModal }: UpsellModalProps) => {
    const { formatMessage } = useIntl()

    return (
        <Modal
            isOpened={isOpened}
            maxWidth={670}
            onClose={closeModal}
            isMobileFullscreen
            hasGlobalHeader
            headerMessage="Suntago Wellness & SPA"
            testIdPrefix="spa-box-about"
        >
            <>
                <SpaModalBody
                    pt={[24, 40]}
                    pb={[80, 40]}
                    pl={[16, 40]}
                    pr={[16, 40]}
                    gap={40}
                >
                    <Gallery>
                        <SinglePhoto
                            photoPath={exampleGalleryPhoto1}
                            alt="massage"
                        />
                        <SinglePhoto
                            photoPath={exampleGalleryPhoto2}
                            alt="essential oils"
                        />
                        <SinglePhoto
                            photoPath={exampleGalleryPhoto3}
                            alt="body scrub"
                        />
                    </Gallery>
                    <Box gap={32}>
                        <IconWithText
                            icon={iconSpa}
                            iconAlt="spa icon"
                            textColor="grayscale_700"
                            gap={24}
                            text={formatMessage(
                                {
                                    id: 'upsells.wellness.modal_professionals_info',
                                    defaultMessage:
                                        '<span>Pełni pasji profesjonaliści</span>, którzy pomogą Ci dobrać zabiegi do Twoich potrzeb.',
                                    description:
                                        'Keep the html tags in the translation',
                                },
                                {
                                    span: (chunks: string[]) => (
                                        <Text
                                            as="span"
                                            variant="body"
                                            color="grayscale_900"
                                        >
                                            {chunks}
                                        </Text>
                                    ),
                                }
                            )}
                        />
                        <IconWithText
                            icon={iconFlipFlops}
                            iconAlt="Flip-Flops icon"
                            textColor="grayscale_700"
                            gap={24}
                            text={formatMessage(
                                {
                                    id: 'upsells.wellness.modal_interiors_info',
                                    defaultMessage:
                                        '<span>Unikatowe wnętrza</span>, zaprojektowane z myślą o relaksie w najlepszym wydaniu',
                                    description:
                                        'Keep the html tags in the translation',
                                },
                                {
                                    span: (chunks: string[]) => (
                                        <Text
                                            as="span"
                                            variant="body"
                                            color="grayscale_900"
                                        >
                                            {chunks}
                                        </Text>
                                    ),
                                }
                            )}
                        />
                        <IconWithText
                            icon={iconJacuzzi}
                            iconAlt="Jacuzzi icon"
                            textColor="grayscale_700"
                            gap={24}
                            text={formatMessage(
                                {
                                    id: 'upsells.wellness.modal_rituals_info',
                                    defaultMessage:
                                        '<span>Wyjątkowe rytuały Suntago</span> inspirowane energią żywiołów.',
                                    description:
                                        'Keep the html tags in the translation',
                                },
                                {
                                    span: (chunks: string[]) => (
                                        <Text
                                            as="span"
                                            variant="body"
                                            color="grayscale_900"
                                        >
                                            {chunks}
                                        </Text>
                                    ),
                                }
                            )}
                        />
                        <IconWithText
                            icon={iconTowels}
                            iconAlt="Towels icon"
                            textColor="grayscale_700"
                            gap={24}
                            text={formatMessage(
                                {
                                    id: 'upsells.wellness.modal_treatments_info',
                                    defaultMessage:
                                        '<span>Ponad 30 zabiegów </span>na twarz, ciało, stopy i dłonie (masaże, zabiegi uzupełniające, rytuały).',
                                    description:
                                        'Keep the html tags in the translation',
                                },
                                {
                                    span: (chunks: string[]) => (
                                        <Text
                                            as="span"
                                            variant="body"
                                            color="grayscale_900"
                                        >
                                            {chunks}
                                        </Text>
                                    ),
                                }
                            )}
                        />
                    </Box>
                    <OpeningHours />
                    <Box direction="column" gap={16} mt={40}>
                        <Text variant="heading5" color="grayscale_900">
                            <FormattedMessage
                                id="upsells.wellness.modal_spa_contraindications_heading"
                                defaultMessage="Przeciwskazania do zabiegów"
                            />
                        </Text>
                        <Text variant="body" color="grayscale_800">
                            <FormattedMessage
                                id="upsells.wellness.modal_spa_contraindications_info"
                                defaultMessage="Przed rezerwacją zapoznaj się z przeciwwskazaniami. W przypadku wykrycia ich w trakcie wizyty, nasi specjaliści, w miarę możliwości, zaproponują zabieg alternatywny."
                            />
                        </Text>
                        <Link
                            path={SPA_CONTRAINDICATIONS_DOC}
                            variant="secondary"
                            textVariant="bodyStrong"
                            icon={null}
                            target="_blank"
                            data-testid="spa-details-modal-link-contraindications"
                        >
                            <FormattedMessage
                                id="upsells.wellness.modal_spa_contraindications_link"
                                defaultMessage="Zobacz listę przeciwwskazań"
                            />
                        </Link>
                    </Box>
                    <Box direction="column" gap={16} mt={40}>
                        <Text variant="heading5" color="grayscale_900">
                            <FormattedMessage
                                id="upsells.wellness.modal_booking_cancel_heading"
                                defaultMessage="Jak zmienić lub odwołać rezerwację"
                            />
                        </Text>
                        <Text variant="body" color="grayscale_800">
                            <FormattedMessage
                                id="upsells.wellness.modal_booking_cancel_info"
                                defaultMessage="Każdą rezerwację możesz zmienić lub odwołać na 1 dzień przed Twoją wizytą, do 19:00. Zmiany możesz dokonać online lub dzwoniąc pod numer: 22 464 44 66."
                            />
                        </Text>
                        <Link
                            path={SUNTAGO_ONLINE_TICKET_SALES_REGULATIONS_LINK}
                            variant="secondary"
                            textVariant="bodyStrong"
                            icon={null}
                            target="_blank"
                            data-testid="spa-details-modal-link-regulations"
                        >
                            <FormattedMessage
                                id="upsells.wellness.modal_booking_regulations_link"
                                defaultMessage="Zobacz regulamin rezerwacji Wellness & SPA"
                            />
                        </Link>
                    </Box>
                </SpaModalBody>
            </>
        </Modal>
    )
}

export default SpaModal
